import Call from './svgs/call.svg';
import Chat from './svgs/chat.svg';
import Email from './svgs/email.svg';
import EmergencyCall from './svgs/emergency-call.svg';

export type IconName = keyof typeof iconMap;
export type Item = {
  icon: IconName;
  title: string;
  description: string;
  isDescriptionUnderlined?: boolean;
};

export const iconMap = {
  call: Call,
  email: Email,
  chat: Chat,
  emergencyCall: EmergencyCall,
} as const;
